export default "__VITE_ASSET__DPe3jVqs__"